(() => {
  const getVisibleHeaderOffset = () => {
    const header = document.querySelector('.fh-header');

    if (!header) return 0;

    const headerStyle = window.getComputedStyle(header);
    const headerRect = header.getBoundingClientRect();
    const isOverlayingContent =
      (headerStyle.position === 'fixed' || headerStyle.position === 'sticky') &&
      headerRect.top <= 1 &&
      headerRect.bottom > 0;

    return isOverlayingContent ? headerRect.height : 0;
  };

  const initialiseFeatureNavigation = () => {
    const featureNavigation = document.getElementById('yvProductFeatureList');

    if (!featureNavigation || featureNavigation.dataset.freshinScrollAware === 'true') return;

    featureNavigation.dataset.freshinScrollAware = 'true';
    const featureLinks = Array.from(featureNavigation.querySelectorAll('.feature-link'));

    const setActiveFeature = (activeLink) => {
      featureLinks.forEach((link) => {
        const isActive = link === activeLink;
        link.parentElement?.classList.toggle('active', isActive);
        if (isActive) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };

    featureLinks.forEach((link) => {
      if (link.classList.contains('active')) link.parentElement?.classList.add('active');
      link.classList.remove('active');
    });

    let scrollFrame = null;
    const updateActiveFeature = () => {
      scrollFrame = null;
      if (!featureNavigation.isConnected) return;

      const readingLine = window.scrollY + getVisibleHeaderOffset() + 32;
      let activeLink = featureLinks[0];

      featureLinks.forEach((link) => {
        const href = link.getAttribute('href');
        const target = href?.startsWith('#') ? document.getElementById(decodeURIComponent(href.slice(1))) : null;
        const targetTop = target ? target.getBoundingClientRect().top + window.scrollY : Number.POSITIVE_INFINITY;

        if (targetTop <= readingLine) activeLink = link;
      });

      if (activeLink) setActiveFeature(activeLink);
    };

    window.addEventListener(
      'scroll',
      () => {
        if (scrollFrame === null) scrollFrame = window.requestAnimationFrame(updateActiveFeature);
      },
      { passive: true }
    );

    featureNavigation.addEventListener('click', (event) => {
      const featureLink = event.target.closest('.feature-link[href^="#"]');

      if (!featureLink || !featureNavigation.contains(featureLink)) return;

      const targetId = decodeURIComponent(featureLink.getAttribute('href').slice(1));
      const target = document.getElementById(targetId);

      if (!target) return;

      event.preventDefault();
      event.stopPropagation();

      const targetTop = target.getBoundingClientRect().top + window.scrollY;
      const visualOffset = getVisibleHeaderOffset() + 24;
      const scrollTop = Math.max(0, targetTop - visualOffset);
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      setActiveFeature(featureLink);

      window.scrollTo({ top: scrollTop, behavior: motion });

      if (window.history?.replaceState) {
        window.history.replaceState(null, '', `#${targetId}`);
      }
    });

    updateActiveFeature();
  };

  const initialiseStickyFooterAwareness = () => {
    const stickyBar = document.getElementById('yvProductStickyBar');
    const collisionTargets = document.querySelectorAll('.services-column-section, .fh-footer');

    if (!stickyBar || collisionTargets.length === 0 || stickyBar.dataset.freshinFooterAware === 'true') return;

    stickyBar.dataset.freshinFooterAware = 'true';
    const visibleTargets = new Set();

    const footerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleTargets.add(entry.target);
          } else {
            visibleTargets.delete(entry.target);
          }
        });

        stickyBar.classList.toggle('freshin-sticky-footer-collision', visibleTargets.size > 0);
      },
      { rootMargin: '0px 0px 80px', threshold: 0 }
    );

    collisionTargets.forEach((target) => footerObserver.observe(target));
  };

  const initialiseProductDetailEnhancements = () => {
    initialiseFeatureNavigation();
    initialiseStickyFooterAwareness();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseProductDetailEnhancements, { once: true });
  } else {
    initialiseProductDetailEnhancements();
  }

  document.addEventListener('shopify:section:load', initialiseProductDetailEnhancements);
})();
